module.exports = __webpack_public_path__ + "static/media/bg.fw.bb90f0f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.fw.jpg
// module id = 105
// module chunks = 2